export default "__VITE_ASSET__aH$FyQWp__"